import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import loadModal from '../../action/loadModal';

@connect()
export default class SocialArea extends React.PureComponent {
  static propTypes = {
    dispatch: React.PropTypes.func.isRequired,
    name: React.PropTypes.string.isRequired,
    label: React.PropTypes.string.isRequired,
    type: React.PropTypes.string,
  };

  handleClick(target) {
    this.props.dispatch(loadModal(target));
  }

  render() {
    return (
      <button
        className={cx('follow-button', `follow-button-${this.props.name}`, { [`follow-button-${this.props.type}`]: this.props.type })}
        onClick={() => this.handleClick(`follow-${this.props.name}`)}
      >
        <span className="icon-container">
          <i className={`icon-${this.props.name}`}>
            <span className="structural">{this.props.label}</span>
          </i>
        </span>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/FollowButton.jsx